import { Control } from './control';
import { gsap } from "gsap";


export class AnimatedCardList extends Control {
    private cards: NodeListOf<HTMLLIElement>;
    private observer: IntersectionObserver | null = null;

    public static selector: string = ".cards-link";

    constructor(containerElement: Element) {
        super(containerElement);

        // elements
        this.cards = this.container.querySelectorAll("li");

        if (this.cards.length === 0) {
            return;
        }

        // animation
        gsap.set(this.cards, { opacity: 0, y: "3em" });

        if (this.container.getBoundingClientRect().top < document.documentElement.clientHeight) {
            this.playAnimation();
        } else {
            this.initObserver();
        }

    }

    private initObserver(): void {

        const observerOptions: IntersectionObserverInit = {
            rootMargin: '0px',
            threshold: 0.2
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.playAnimation();
                    // Clean up: stop observing the container immediately
                    if (this.observer) {
                        this.observer.unobserve(this.container);
                        this.observer.disconnect();
                    }
                }
            });
        }, observerOptions);

        this.observer.observe(this.container);
    }

    private playAnimation(): void {
        gsap.to(this.cards, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'back',
            stagger: 0.15
        });
    }
}
